import React, { useRef, useEffect } from "react"
import propTypes from "prop-types"
import IconSvg from "@atoms/IconSvg/IconSvg"
import closeIcon from "@images/svg/close.svg"

const FilterTextField = ({
  listToFilter,
  initialList,
  updateList,
  placeholder,
  useShadow = true,
}) => {
  const inputRef = useRef(null)

  useEffect(() => {
    // Focus the input when the component mounts
    inputRef.current?.focus()
  }, [])

  const onChangeHandler = (value) => {
    const updatedList = value
      ? listToFilter?.filter((item) =>
          item.label.toLowerCase().includes(value.toLowerCase())
        )
      : initialList

    updateList(updatedList)
  }

  const clearList = () => {
    inputRef.current.value = ""
    updateList(initialList)
  }

  return (
    <div className={"relative"}>
      <input
        ref={inputRef}
        className={`outline-brand-blue ${
          useShadow ? "shadow-textInput focus:shadow-none" : ""
        } border border-brand-deepblack rounded-xs px-2 py-2.5 placeholder-brand-deepblack color-brand-deepblack w-full text-sm leading-none font-inter`}
        type={"text"}
        placeholder={placeholder}
        onChange={(e) => onChangeHandler(e.target.value)}
      />
      <button
        onClick={() => clearList()}
        className={"absolute inset-y-0 right-2"}
      >
        <IconSvg
          Icon={closeIcon}
          widthClass="w-3.5 ml-2.5"
          customClasses="text-brand-blue"
        />
      </button>
    </div>
  )
}

FilterTextField.propTypes = {
  listToFilter: propTypes.arrayOf(
    propTypes.shape({
      label: propTypes.string.isRequired,
      name: propTypes.string,
    })
  ),
  initialList: propTypes.arrayOf(
    propTypes.shape({
      label: propTypes.string.isRequired,
      name: propTypes.string,
    })
  ),
  updateList: propTypes.func.isRequired,
  placeholder: propTypes.string.isRequired,
}

export default FilterTextField
